import { render, staticRenderFns } from "./userDetail_childList_learner.vue?vue&type=template&id=747ee975&"
import script from "./userDetail_childList_learner.vue?vue&type=script&lang=js&"
export * from "./userDetail_childList_learner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports